import React, { Component } from "react";
import LabBasicInfoView from "./LabBasicInfoView";

export default class LabBasicInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: {}
    };
  }

  render() {
    const { details } = this.props;

    return <>{details && <LabBasicInfoView details={details} />}</>;
  }
}
